import React from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import Header from './Header';
import { getColumns, getNoDataText, DEFAULTSORTED, DEFAULTPAGESIZE } from './table.conf.js';

const Competitors = (props) => {
  const { data, events, competitions, onSelectEvent, onSelectCompetition } = props;
  
  return (
    <div>
      <Header
        title={''}
        events={events}
        competitions={competitions}
        onSelectEvent={onSelectEvent}         
        onSelectCompetition={onSelectCompetition}
      />
      <ReactTable
        className='-striped -highlight'
        data={data}
        columns={getColumns()}
        defaultSorted={DEFAULTSORTED}
        defaultPageSize={DEFAULTPAGESIZE}
        noDataText={getNoDataText()}
      />
    </div>
  );
};

export default Competitors;



// WEBPACK FOOTER //
// ./src/private/user/components/Competitors/index.js